import {
  ContactFieldApiInterface,
  ContactFilterType,
} from 'modules/contacts/types/contact-filter-interface'
import { getDefaultFilterValue } from 'modules/contacts/utils/get-default-filter-value'

export const getCustomDefaultFilters = (
  filterFields: ContactFieldApiInterface['items'],
): ContactFilterType =>
  filterFields.reduce((obj, el) => {
    return { ...obj, [el.slug]: getDefaultFilterValue(el.slug) }
  }, {})
